import "./index.scss";
import { MenuOpeningStatus } from "components/HeaderNew/HeaderFull";
import React from "react";
import cn from "classnames";

type Props = {
  onClick: (status: MenuOpeningStatus) => void;
  menuOpeningStatus: MenuOpeningStatus;
};

const HamburgerMenu = ({ onClick, menuOpeningStatus }: Props) => {
  const isOpen =
    menuOpeningStatus === "groupOpen" || menuOpeningStatus === "submenuOpen";

  const handleClick = () => {
    if (menuOpeningStatus === "groupOpen") return onClick("fullClose");
    if (menuOpeningStatus === "submenuOpen") return onClick("close");
    return onClick("submenuOpen");
  };

  return (
    <button
      // TODO check if aria-label can come from trasnslations object
      aria-label={isOpen ? "Close menu" : "Open menu"}
      type="button"
      className="hamburger-menu"
      onClick={handleClick}
    >
      <div
        className={cn("hamburger-menu__icon", {
          "hamburger-menu--open": isOpen,
        })}
      >
        <span />
        <span />
        <span />
        <span />
      </div>
    </button>
  );
};

export default HamburgerMenu;
